<div class="single-post notice-post">
    <div class="container">		
        <div class="post-header">
            <h2 class="h-medium">{{noticeDetail.title}}</h2>			
            <div class="post-meta row">
                <ng-container *ngIf="listFile != null && listFile.length > 0">
                    <ng-container *ngFor="let items of listFile ">                    
                        <div class="post-info info col-auto">
                            <a class="info author col-auto" (click)="downloadFile(items)" style="cursor: pointer;">
                                <container-element [ngSwitch]="items.type">
                                    <img *ngSwitchCase="'zip'" src="/assets//img/icons/zip.svg">
                                    <img *ngSwitchCase="'doc'" src="/assets//img/icons/doc.svg">
                                    <img *ngSwitchCase="'xlsx'" src="/assets//img/icons/xlsx.svg">
                                    <img *ngSwitchCase="'image'" src="/assets//img/icons/file.svg">
                                    <img *ngSwitchDefault src="/assets/img/icons/file.svg">
                                </container-element>
                                <span>{{items.fileNameOrg}}</span>
                            </a>
                        </div>
                    </ng-container>                
                </ng-container>	
            </div>
        </div>
        <div class="post-body" id="postBody">
            <div [innerHTML]="contents ? (contents | renderHtml) : ''"></div>
        </div>



        <div class="row post-foot">
            <div class="prev col">
                <a *ngIf="noticeDetail.preNo != null && noticeDetail.preNo != '0' && noticeDetail.preTitle != null" style="cursor: pointer;"
                (click)="onClickPrevNext(noticeDetail.preNo)" >
                    <div class="carret left">
                        <img src="../../assets/img/icons/carret-right.svg">
                    </div>
                    <span>{{noticeDetail.preTitle}}</span>
                </a>
            </div>
            <div class="next-post col-auto">
                <a *ngIf="noticeDetail.nextNo != null && noticeDetail.nextNo != '0' && noticeDetail.nextTitle != null" style="cursor: pointer;"
                (click)="onClickPrevNext(noticeDetail.nextNo)">
                    <span>{{noticeDetail.nextTitle}}</span>
                    <div class="carret right">
                        <img src="../../assets/img/icons/carret-right.svg">
                    </div>
                </a>
                
            </div>
        </div>
    </div>
</div>
